import { useContext } from '@nuxtjs/composition-api';

export const search = (row, col, cellValue, search) => {
    if (cellValue && cellValue.length > 2) {
        if (search.substring(0, 1) === '>') {
            let el = search.split('>');

            if (cellValue !== ' ') {
                return Number(cellValue) > el[1];
            }
        }

        if (search.substring(0, 1) === '<') {
            let el = search.split('<');

            if (cellValue !== ' ') {
                return Number(cellValue) < el[1];
            }
        }

        if (search.substring(0, 1) === '=') {
            let el = search.split('=');

            return cellValue.toString().toUpperCase() === el[1].toString().toUpperCase();
        }

        let split = search.toString().toUpperCase().split(' ').filter(Boolean);

        if (split.length > 1) {
            let el = Object.values(row).filter(Boolean);

            return split.every(
                i => el.some(str => str.toString().toUpperCase().includes(i))
            );
        } else {
            return cellValue.toString().toUpperCase().includes(search.toString().toUpperCase().trim());
        }
    }

    return false;
};

export const pagination = (perPage = 20, enabled = true) => {
    const { app } = useContext();

    return {
        enabled: enabled,
        mode: 'pages',
        perPage: perPage,
        position: 'bottom',
        perPageDropdown: [perPage, perPage * 2, perPage * 3],
        dropdownAllowAll: false,
        firstLabel: app.i18n.t('First Page'),
        lastLabel: app.i18n.t('Last Page'),
        nextLabel: app.i18n.t('next'),
        prevLabel: app.i18n.t('prev'),
        rowsPerPageLabel: app.i18n.t('Rows per page'),
        ofLabel: app.i18n.t('of'),
        pageLabel: app.i18n.t('page'),
        allLabel: app.i18n.t('All'),
    };
};